import React from 'react'
import CountUp from 'react-countup';

const FunFact = (props) => {
    return (
        <section className={" section-padding " + props.hclass}>
            <div className="container">
                <div className="fun-fact-wrap">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="info">
                                <h3><span><CountUp end={322} enableScrollSpy /></span></h3>
                                <p>Children's
                                    Life Saved</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="info">
                                <h3><span>+<CountUp end={1.4} enableScrollSpy decimals={1}  />M</span></h3>
                                <p>Total
                                    Fund Applied</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="info">
                                <h3><span><CountUp end={1000} enableScrollSpy /></span></h3>
                                <p>Annual Target of Beneficiaries  </p>
                            </div>
                        </div>
                        {/* <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div className="info">
                                <h3><span><CountUp end={80} enableScrollSpy /></span></h3>
                                <p>Founder's Impact</p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FunFact;




